const accessibilityStatement = () => {
  return (
    <div className='absolute -left-full'>
      <p
        id="statement"
        className='w-0 h-0 overflow-hidden'
      >
        Cove is actively dedicating resources to make our site, and our
        community, more accessible. While we make changes, if you need any
        assistance accessing the information on this site, please contact us at
        855.268.3669 or support@covesmart.com. For those who are deaf or hard of
        hearing or who do not use voice channels to communicate, please contact
        us via email or via 711 or other relay services. If you have any
        feedback or suggestions as to how we could improve the accessibility of
        our website, please contact us at accessibility@covesmart.com. Please be
        aware that our site may contain links to other websites, the
        accessibility of which is not under our control. Please contact us if
        you run into any difficulties with these sites, and we will do our best
        to help you.
      </p>
      <a
        aria-label="link to accessibility page"
        aria-describedby="statement"
        href="/accessibility/"
      >
        Accessibility
      </a>
    </div>
  );
};

export default accessibilityStatement;
